import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { GlobalsPaths } from 'app/app.config';
import { PaginationParams } from 'app/_models/generic';
import { SimpleVehicleFmt, Vehicle } from 'app/_models/vehicle';
import { VehiclesService } from 'app/_services/vehicles.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { debounceTime, switchMap, takeUntil, skip, tap, finalize, filter, distinctUntilChanged } from 'rxjs/operators';

export interface ISelectedVehicle {
    id: number;
    registration: string;
    vehicle_type: string;
}

const autocomplete = (time, selector) => (source$) =>
    source$.pipe(
        // wait 300ms after each keystroke before considering the term
        debounceTime(time),
        // ignore new search term if fewer than 3 characters
        filter((term: string) => source$.value.length > 2),
        // ignore new term if same as previous term
        distinctUntilChanged(),
        tap(() => {
            AutocompleteVehiclesComponent.isLoading = true;
        }),
        // switch to new search observable each time the term changes
        switchMap((...args: any[]) =>
            selector(...args)
                .pipe(
                    takeUntil(
                        source$
                            .pipe(
                                skip(1),
                                finalize(() => {
                                    AutocompleteVehiclesComponent.isLoading = false;
                                })
                            )
                    )
                )
        )
    );

@Component({
    selector: 'app-autocomplete-vehicles',
    templateUrl: './autocomplete-vehicles.component.html',
    styleUrls: ['./autocomplete-vehicles.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AutocompleteVehiclesComponent implements OnInit {

    static isLoading: boolean = false;
    readonly term$ = new BehaviorSubject<string>('');
    img: string = this.globalsPaths.img;
    selectedVehicle: SimpleVehicleFmt = null;
    openVehicleList: boolean = false;
    results$ = this.term$.pipe(
        autocomplete(600, (term => this.fetch(term)))
    );
    private _inputResetVehicle: boolean = false;

    @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
    // @Input() inputResetVehicle: () => void;
    @Output() outputVehicle: EventEmitter<SimpleVehicleFmt> = new EventEmitter<SimpleVehicleFmt>();

    constructor(
        private vehicleService: VehiclesService,
        private globalsPaths: GlobalsPaths
    ) { }

    @Input()
    set inputResetVehicle(val: boolean) {
        /*console.log('previous item = ', this._inputResetVehicle);
        console.log('currently selected item=', val);*/
        this._inputResetVehicle = val;
        this.clearVehicle();
        // Put variable back to false by default
        this._inputResetVehicle = false;
    }
   
    // use getter setter to define the property
    get resetVehicle(): any {
        return this._inputResetVehicle;
    }

    // use getter setter to define the property
    get loading(): boolean {
        return AutocompleteVehiclesComponent.isLoading;
    }

    ngOnInit() {
    }

    public selectAFilteredVehicle(event) {
        // console.log('selectAFilteredVehicle, ', event);
        const _selectedVehicle: SimpleVehicleFmt = event;
        this.selectedVehicle = _selectedVehicle;
        this.autocompleteInput.nativeElement.value = '';
        this.outputVehicle.emit(this.selectedVehicle);
    }

    public clearVehicle() {
        this.selectedVehicle = null;
        this.term$.next('');
        this.autocompleteInput.nativeElement.value = '';
        this.outputVehicle.emit(this.selectedVehicle);
    }

    enterPressed(event) {
        const strippedValue = this.autocompleteInput.nativeElement.value.trim();
        this.term$.next(strippedValue);
    }

    public onFocus(event) {
        if (event) {
            this.openVehicleList = true;
        } else {
            setTimeout(() => {
                this.openVehicleList = false;
            }, 600);

        }
    }

    public getIconUrl(vehicleTypeRef: string): string {
        if (vehicleTypeRef) {
            return `${this.img}icons/${vehicleTypeRef.toLowerCase()}-icon.${vehicleTypeRef !== 'FUEL' ? 'svg' : 'png'}`;
        } else {
            return '-';
        }
    }

    fetch(term: string): Observable<any> {
        const _paginationParams: PaginationParams = { pageSize: 15, page: 1, orderingDirection: '-', ordering: 'registration', search: '' };
        return this.vehicleService.getSimpleVehicleList(_paginationParams, term);
    }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/autocomplete-vehicles/autocomplete-vehicles.component.ts